import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { Button } from '@outdoor-voices/ui';
import { InView } from 'react-intersection-observer';
import cc from 'classcat';
import PropTypes from 'prop-types';
import React, { memo } from 'react';
import css from './CollectionSet.module.scss';
import List from './List';
import CompareOverlay from '../CompareOverlay';
import { OVContextProvider } from '../../utils/OVContext';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var componentMap = {
  ASSET_LEFT: 'assetLeft',
  ASSET_RIGHT: 'assetRight',
  COLLECTION_SET: 'collectionSet',
  DEFAULT_GRID: 'defaultGrid'
};
var threshold = 0.1;

var ProductSet = function ProductSet(_ref) {
  var component = _ref.component,
      compareAds = _ref.compareAds,
      compareLinkText = _ref.compareLinkText,
      cta = _ref.cta,
      description = _ref.description,
      displaySwatches = _ref.displaySwatches,
      index = _ref.index,
      image = _ref.image,
      isMobile = _ref.isMobile,
      noMargin = _ref.noMargin,
      products = _ref.products,
      setCurrentIndex = _ref.setCurrentIndex,
      subtitle = _ref.subtitle,
      title = _ref.title,
      url = _ref.url;

  var onChange = function onChange(isInView, entry) {
    var intersectionRatio = entry.intersectionRatio,
        isIntersecting = entry.isIntersecting;
    var shouldShow = isIntersecting && intersectionRatio >= 0.1;

    if (isInView && shouldShow) {
      setCurrentIndex(index);
    }
  };

  var componentType = componentMap[component];
  var ctaButton = cta && url ? /*#__PURE__*/_jsx("div", {
    className: css.cta,
    children: /*#__PURE__*/_jsx(Button, {
      big: true,
      href: url,
      children: cta
    })
  }) : /*#__PURE__*/_jsx(_Fragment, {});

  if (componentType && componentType.indexOf('asset') > -1) {
    var inlineHeader = {
      componentType: componentType,
      description: description,
      image: image,
      subtitle: subtitle,
      title: title
    };
    return /*#__PURE__*/_jsxs(InView, {
      className: cc([css.content, _defineProperty({}, css.noMargin, index === 0 && noMargin)]),
      id: "product-set-".concat(index),
      onChange: onChange,
      threshold: threshold,
      children: [/*#__PURE__*/_jsxs("header", {
        className: cc([css.header, css.inlineMobileHeader, css.isMobile]),
        children: [/*#__PURE__*/_jsx("h2", {
          className: css.title,
          children: title
        }), subtitle && /*#__PURE__*/_jsx("h3", {
          className: css.subtitle,
          children: subtitle
        })]
      }), /*#__PURE__*/_jsx(List, {
        displaySwatches: displaySwatches,
        gridLayout: true,
        inlineHeader: inlineHeader,
        isMobile: isMobile,
        products: products
      }), ctaButton]
    });
  }

  return /*#__PURE__*/_jsxs(InView, {
    onChange: onChange,
    id: "product-set-".concat(index),
    className: cc([css.content, _defineProperty({}, css.noMargin, index === 0 && noMargin)]),
    threshold: threshold,
    children: [/*#__PURE__*/_jsxs("header", {
      className: css.header,
      children: [/*#__PURE__*/_jsx("h2", {
        className: css.title,
        children: title
      }), subtitle && /*#__PURE__*/_jsx("h3", {
        className: css.subtitle,
        children: subtitle
      }), description && /*#__PURE__*/_jsxs("p", {
        className: css.description,
        children: [description, compareAds.length !== 0 && /*#__PURE__*/_jsx(OVContextProvider, {
          children: /*#__PURE__*/_jsx(CompareOverlay, {
            compareAds: compareAds,
            isMobile: isMobile,
            linkText: compareLinkText
          })
        })]
      })]
    }), /*#__PURE__*/_jsx("div", {
      className: cc([css.productsWrap, css[componentType]]),
      children: /*#__PURE__*/_jsx(List, {
        isMobile: isMobile,
        products: products,
        displaySwatches: displaySwatches
      })
    }), ctaButton]
  });
};

ProductSet.defaultProps = {
  compareAds: [],
  compareLinkText: '',
  description: '',
  image: {},
  noMargin: false,
  subtitle: ''
};
ProductSet.propTypes = {
  compareAds: PropTypes.array,
  compareLinkText: PropTypes.string,
  component: PropTypes.string,
  cta: PropTypes.string,
  displaySwatches: PropTypes.bool.isRequired,
  description: PropTypes.string,
  image: PropTypes.shape({
    src: PropTypes.string.isRequired,
    alt: PropTypes.string.isRequired
  }),
  index: PropTypes.number.isRequired,
  isMobile: PropTypes.bool.isRequired,
  products: PropTypes.shape().isRequired,
  noMargin: PropTypes.bool,
  setCurrentIndex: PropTypes.func.isRequired,
  subtitle: PropTypes.string,
  title: PropTypes.string.isRequired,
  url: PropTypes.string
};
export default /*#__PURE__*/memo(ProductSet);